<template>
    <div class="member">
      <div class="tabTitle  mt-60" :gutter="20" >
        <el-tabs v-model="position_type" type="card" @tab-click="changeType(position_type)" >
          <el-tab-pane :label="(item.name)" :name="item.nub" v-for="item,index in tabs" :key="index">
            <div class="member-out">
              <div class="member-out-conter">
                <div v-for="info,a in list" :key="a">
                  <div class="conter-row" @click="jumpUrl(info.unit_site)">
                    <div>{{info.company}}{{info.request_id}}</div>
                    <div>{{info.position}}</div>
                  </div>
                </div>
              </div> 
            </div>
          </el-tab-pane>          
        </el-tabs>
      </div>
    </div>
</template>
<script>
export default {
  props:{
    list:{
      type:Array,
      default: () => ({})
    }
  },
  data () {
    return {
      type:'add',
      tabs:[{name:'会长/副会长',nub:'1'},{name:'理事/监事长/监事',nub:'2'},{name:'会员',nub:'3'}],
      param:{
                pageIndex:1,
                pageSize:10,
            },
    }
  },
  created(){
    this.position_type = '1'
  },
  methods: {
    changeType(flg){
      this.$emit('handleMember',flg);
    },
    jumpUrl(url){
      if (url) {
        window.open(url, 'blank');
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './Member.scss';
</style>
<style lang="scss">
.tabTitle{
  .el-tabs__item.is-active{
    color: #FFF;
    background: #134B9F;
  }
}
</style>
